import DOMPurify from "dompurify";

/**
 * Sanitize untrusted HTML for safe rendering (e.g. CMS, APIs, product descriptions).
 * Blocks executable/embed content; allows common rich-text tags and attributes.
 */
function sanitizeRichTextHtml(html: string): string {
	return DOMPurify.sanitize(html, {
		FORBID_TAGS: ["script", "iframe", "object", "embed", "form"],
		ALLOWED_ATTR: [
			"style",
			"class",
			"href",
			"target",
			"rel",
			"title",
			"src",
			"alt",
			"width",
			"height",
		],
		ALLOW_DATA_ATTR: false,
	});
}

export { sanitizeRichTextHtml };
